import { render, staticRenderFns } from "./FormCreateShippingAddress.vue?vue&type=template&id=f4be6a1c&scoped=true"
import script from "./FormCreateShippingAddress.vue?vue&type=script&lang=js"
export * from "./FormCreateShippingAddress.vue?vue&type=script&lang=js"
import style0 from "./FormCreateShippingAddress.vue?vue&type=style&index=0&id=f4be6a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4be6a1c",
  null
  
)

export default component.exports